<template>
  <div class="mc-import">
    <div @click="visible = true">
      <slot><el-button type="primary">导入</el-button></slot>
    </div>
    <el-dialog :title="$attrs['title'] || '导入'" :visible.sync="visible" :width="width" :before-close="close" class="mc-import-pop" append-to-body>
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item prop="file">
          <el-upload
            :name="name"
            :action="action"
            :data="data"
            :multiple="$attrs['multiple']"
            :limit="$attrs['limit'] || 1"
            :auto-upload="false"
            :accept="accept"
            :with-credentials="true"
            :file-list="fileList"
            ref="upload"

            :on-change="onChange"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :on-error="onError"
            >
            <el-button slot="trigger" size="small" @click="clearData">选择文件</el-button>
            <el-button size="small" type="success" @click="onSubmit">上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <a :href="downloadUrl" class="tpl" v-if="downloadUrl">模板下载</a>
            <div slot="tip">
              <p class="tips">只能上传{{accept}}文件，且不超过{{maxSize}}MB</p>
              <p class="error-msg">{{errorMsg}}</p>
            </div>
          </el-upload>
          <div class="mod-tips"><slot name="tips"></slot></div>
        </el-form-item>
      </el-form>
      <!-- 导入结果 -->
      <div class="result" v-if="$attrs['result'] !== undefined && !!msg">
        <h3>导入结果</h3>
        <p>{{msg}}</p>
      </div>
      <!-- 自定义导入结果 -->
      <slot name="result" :data="successData"/>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'mc-import',
    data () {
      return {
        visible: false,
        successData: null,
        msg: '',
        fileList: [],
        errorMsg: '',
        form: {
          file: ''
        },
        rules: {
          file: [{required: true, message: '请上传文件', trigger: 'change'}]
        }
      }
    },
    computed: {
      width () {
        return this.$attrs['width'] || '40%'
      },
      // 请求字段
      name () {
        return this.$attrs['name'] || 'file'
      },
      accept () {
        return this.$attrs['accept'] || '.xls,.xlsx'
      },
      action () {
        return this.$attrs['action'] || ''
      },
      downloadUrl () {
        return this.$attrs['download-url'] || ''
      },
      // ajax传参
      data () {
        return this.$attrs['data'] || {}
      },
      // 以MB为单位
      maxSize () {
        return this.$attrs['max-size'] || 20
      }
    },
    methods: {
      close () {
        this.visible = false
      },
      onSuccess (rs, file, fileList) {
        if (rs && rs.code === 0) {
          this.form.file = []
          this.$message.success('导入成功')
          this.$emit('success', rs.result)
          this.successData = rs.result
          this.msg = rs.msg
        } else {
          this.errorMsg = rs.msg
          this.$emit('error', {rs, file, fileList})
        }
        this.$refs.upload.clearFiles(fileList)
      },
      onError (err, file, fileList) {
        if (err) {}
        this.successData = null
        this.errorMsg = file.name + '上传失败!'
        this.$emit('error', {err, file, fileList})
        this.$refs.upload.clearFiles()
      },
      onChange (file, fileList) {
        this.form.file = fileList
      },
      clearData () {
        this.msg = ''
        this.successData = null
        this.errorMsg = ''
      },
      beforeUpload (file) {
        this.clearData()
        const fileName = file.name.split('.').pop()
        const acceptAr = this.accept.split(',')
        const isX = acceptAr.indexOf('.' + fileName) > -1
        const isLt2M = file.size / 1024 / 1024 < this.maxSize

        if (!isX) {
          this.$message.error(`上传文件只能是 ${this.accept}格式！`)
        }
        if (!isLt2M) {
          this.$message.error(`上传文件大小不能超过 ${this.maxSize}MB!`)
        }
        return (isX) && isLt2M
      },
      onSubmit () {
        this.clearData()
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$refs.upload.submit()
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mc-import {
    display: inline-block;
  }
  .mod-tips {
    font-size: 12px;
    line-height: normal;
  }
  /deep/.el-form-item {
    margin-bottom: 10px;
  }
  .mc-import-pop {
    .el-form {
      min-height: 120px;
    }
    .tpl {
      color: #409eff;
    }
    .tips {
      font-size: 12px;
      padding: 10px 0px 2px;
      line-height: normal;
    }
    .error-msg {
      color: red;
      font-size: 12px;
      padding: 0px;
    }
    .result {
      padding: 10px 0px 10px;
      border-top: 1px solid #eee;
      p {
        padding-top: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mc-ui/import/index.vue